// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { ImageCommonFragmentDoc } from './imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from './imageSize.fragment.generated';
export const CmsImageSizesFragmentDoc = `
    fragment cmsImageSizes on Image {
  ...imageCommon
  url
  width
  sizes(names: [W250, W320, W480, W640, W768, W1024, W1440, W1920, W2560]) {
    ...imageSize
  }
}
    `;